// extracted by mini-css-extract-plugin
module.exports = {"CoursesTiles__item":"CoursesTiles_CoursesTiles__item__2zniJ"};